























import { Vue, Component, Prop } from 'vue-property-decorator';
import postCom from '@/components/CreatePostComponent.vue';
import HomePostView from '@/components/HomePostView.vue';

@Component({
  components: {
    postCom,
    HomePostView,
  },
})
export default class PostView extends Vue {
  time = new Date();

  posts = [];

  tabs = null;

  icon = true;

  showComments = [];

  editedIndex = -1;

  get userPosts() {
    return this.$store.state.homePagePosts
      .filter((createdposts: any) => createdposts.createdBy.uid === this.userProfileView.uid);
  }

  get userProfileView() {
    if (this.$store.state.profileUser === null) {
      return {};
    }
    return this.$store.state.profileUser;
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }
}
